import { images } from "../../../../Assets/assetsHelper";
import "./MissionDetails.css";
import { BarLoader } from "react-spinners";
import { useNavigate } from "react-router";
import { display, fontSize } from "@mui/system";
import { Box, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import PrimaryButton from "../../../../Components/Atoms/Buttons/Primary/PrimaryButton";
import { BaseURL } from "../../../../Hooks/URL";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  "&:first-child": {
    borderRadius: "5px 0 0 0",
  },
  "&:last-child": {
    borderRadius: "0 5px 0 0",
  },
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#6a0505",
    color: theme.palette.common.white,
    fontSize: "15px",
  },
}));

const columns = [
  {
    id: "code",
    label: "Team Code",
    minWidth: 50,
  },
  {
    id: "name",
    label: "Team Name",
    minWidth: 100,
  },
  {
    id: "submission",
    label: "Submission",
    minWidth: 100,
  },
  {
    id: "hasScoringReport",
    label: "",
    minWidth: 100,
    align: "right",
  },
];

function MissionDetails({ loading, url, teams, id, setGoSave, addLoading }) {
  const navigate = useNavigate();
  return (
    <div className="mainContainer">
      {teams?.mission && !loading ? (
        <div className="Cont">
          <div className="greyBox">
            <Box sx={{ width: "100%", display: "flex", flexWrap: "wrap" }}>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Mission Name: </h4>
                  <h3>{teams?.mission?.name}</h3>
                </div>
              </div>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Mission Number: </h4>
                  <h3>{teams?.mission?.order}</h3>
                </div>
              </div>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Cateogry: </h4>
                  <h3>{teams?.mission?.category?.name}</h3>
                </div>
              </div>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Age Group: </h4>
                  <h3>{teams?.mission?.category?.ageGroup?.name}</h3>
                </div>
              </div>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Submission Status: </h4>
                  <h3>{teams?.mission?.submissionStatus}</h3>
                </div>
              </div>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Judging Status: </h4>
                  <h3>{teams?.mission?.judgingStatus}</h3>
                </div>
              </div>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Date Time: </h4>
                  <h3>
                    {teams?.mission?.dateTime
                      ? new Date(teams?.mission?.dateTime).toLocaleString()
                      : "-"}
                  </h3>
                </div>
              </div>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Start Date Time: </h4>
                  <h3>
                    {teams?.mission?.submissionStartDateTime
                      ? new Date(
                          teams?.mission?.submissionStartDateTime
                        ).toLocaleString()
                      : "-"}
                  </h3>
                </div>
              </div>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>End Date Time: </h4>
                  <h3>
                    {teams?.mission?.submissionEndDateTime
                      ? new Date(
                          teams?.mission?.submissionEndDateTime
                        ).toLocaleString()
                      : "-"}
                  </h3>
                </div>
              </div>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Completed: </h4>
                  <h3>
                    {teams?.mission?.judgeMissionJudging?.completed
                      ? "Completed"
                      : "Not completed"}
                  </h3>
                </div>
              </div>
              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Completion Date: </h4>
                  <h3>
                    {teams?.mission?.judgeMissionJudging?.completionDate
                      ? new Date(
                          teams?.mission?.judgeMissionJudging?.completionDate
                        ).toLocaleDateString()
                      : "-"}
                  </h3>
                </div>
              </div>

              <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                <div>
                  <h4>Task Type: </h4>
                  <h3>{teams?.mission?.task?.type}</h3>
                </div>
              </div>
              {teams?.mission?.task?.filePath ? (
                <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                  <div>
                    <h4>Task File: </h4>
                    <a
                      style={{ marginTop: "5px", display: "block" }}
                      href={`${BaseURL}/${teams?.mission?.task?.filePath}`}
                      target="_blank"
                    >
                      Download Task File
                    </a>
                  </div>
                </div>
              ) : (
                ""
              )}
              {teams?.mission?.task?.numberOfQuestions ? (
                <div className="greyNumberBox" style={{ minWidth: "200px" }}>
                  <div>
                    <h4>Task Questions: </h4>
                    <h2>{teams?.mission?.task?.numberOfQuestions}</h2>
                  </div>
                </div>
              ) : (
                ""
              )}
              {console.log(teams)}
              {teams?.teams
                ?.map((item) => item?.hasScoringReport)
                ?.every((mis) => mis == 1) &&
              !teams?.mission?.judgeMissionJudging?.completed ? (
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    marginTop: "10px",
                  }}
                >
                  <PrimaryButton
                    classBtn={"center"}
                    text={"Complete Mission"}
                    loading={addLoading}
                    style={{
                      textTransform: "capitalize",
                      borderRadius: "5px",
                      color: "var(--text-secondary)",
                      backgroundColor: "var(--primary)",
                      height: "35px",
                      padding: "0 15px",
                      minWidth: "100px",
                      textWrap: "noWrap",
                    }}
                    click={() => setGoSave(true)}
                  />
                </Box>
              ) : (
                ""
              )}
            </Box>
          </div>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0px",
            }}
          >
            <Typography
              variant={"h3"}
              sx={{
                fontSize: { xs: "20px", md: "25px" },
                margin: "10px 0",
                textAlign: "start",
                fontWeight: "700",
              }}
            >
              Teams:
            </Typography>
          </Box>
          <Paper
            className="tableCont"
            sx={{ width: "fit-content", minWidth: "100%" }}
          >
            {teams?.teams?.length && !loading ? (
              <>
                <TableContainer>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column) => (
                          <StyledTableCell
                            key={column.id}
                            align={column.align}
                            style={{
                              minWidth: column.minWidth,
                            }}
                          >
                            {column.label}
                          </StyledTableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {teams?.teams?.map((team) => {
                        return (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={team.id}
                            style={{ cursor: "pointer" }}
                          >
                            {columns.map((column) => {
                              const value = team[column.id];
                              return (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  style={{ padding: "10px" }}
                                >
                                  {column.id == "hasScoringReport" ? (
                                    value ? (
                                      <PrimaryButton
                                        classBtn={"center small"}
                                        text={"Show Report"}
                                        style={{
                                          textTransform: "capitalize",
                                          borderRadius: "5px",
                                          color: "var(--text-secondary)",
                                          backgroundColor: "var(--primary)",
                                          height: "30px",
                                          padding: "0 10px",
                                          minWidth: "100px",
                                          textWrap: "noWrap",
                                          fontSize: "10px",
                                        }}
                                        click={() =>
                                          navigate(
                                            `/missions/${id}/teams/${team?.id}/report`
                                          )
                                        }
                                      />
                                    ) : (
                                      <PrimaryButton
                                        classBtn={"center small"}
                                        text={"Evaluate Now"}
                                        style={{
                                          textTransform: "capitalize",
                                          borderRadius: "5px",
                                          color: "var(--text-secondary)",
                                          backgroundColor: teams?.mission
                                            ?.judgeMissionJudging?.completed
                                            ? "grey"
                                            : "var(--primary)",
                                          height: "30px",
                                          padding: "0 10px",
                                          minWidth: "100px",
                                          textWrap: "noWrap",
                                          fontSize: "10px",
                                        }}
                                        disabled={
                                          teams?.mission?.judgeMissionJudging
                                            ?.completed
                                        }
                                        click={() =>
                                          navigate(
                                            `/missions/${id}/teams/${team?.id}`
                                          )
                                        }
                                      />
                                    )
                                  ) : column.id == "submission" ? (
                                    value?.missionTaskType == "mission" ? (
                                      value?.submittedFilePath ? (
                                        <a
                                          style={{
                                            marginTop: "5px",
                                            display: "block",
                                          }}
                                          href={`${BaseURL}/${value?.submittedFilePath}`}
                                          target="_blank"
                                        >
                                          Download Submission
                                        </a>
                                      ) : (
                                        "-"
                                      )
                                    ) : value?.missionTaskType == "mcq" ? (
                                      value?.mcqAnswers?.length > 0 ? (
                                        value?.mcqAnswers?.toLocaleString()
                                      ) : (
                                        "-"
                                      )
                                    ) : (
                                      "-"
                                    )
                                  ) : (
                                    value ?? "-"
                                  )}
                                </TableCell>
                              );
                            })}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                  {!teams?.teams?.length ? (
                    <h3 style={{ textAlign: "center", margin: "50px" }}>
                      No teams Added Yet!!
                    </h3>
                  ) : (
                    ""
                  )}
                </TableContainer>
                {/* <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={pageCount * rowsPerPage}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                /> */}
              </>
            ) : (
              <div className="loadingBox">
                <BarLoader color="#6a0505" />
              </div>
            )}
          </Paper>
        </div>
      ) : (
        <div className="loadingBox">
          <BarLoader color="#6a0505" />
        </div>
      )}
    </div>
  );
}

export default MissionDetails;
